module.exports = __webpack_public_path__ + "img/dataCensus_vote.3b0fe460.svg";